import React from 'react';
import { styled } from '@mui/material/styles';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import { Divider } from '@mui/material';
import Logout from '@mui/icons-material/ExitToApp';
import {
  USER_ACCOUNT_PATHS,
  LINKS,
  PAGE_PATHS
} from '../../constants/constants';
import Link from 'next/link';

const PREFIX = 'UserMenu';

const classes = {
  root: `${PREFIX}-root`
};

const StyledMenu = styled(Menu)({
  [`& .${classes.root}`]: {
    fontFamily: 'Panton-Regular',
    fontSize: '14px'
  }
});

const CustomMenuItem = MenuItem;
type UserMenuProps = {
  id: string;
  anchorEl: HTMLElement | null;
  userMenuOpen: boolean;
  handleUserMenuClose: () => void;
  handleLogout: () => void;
  showProfessionalLinks: boolean;
  showWelcomeHighlight?: boolean;
};

const UserMenu = ({
  id,
  anchorEl,
  userMenuOpen,
  handleUserMenuClose,
  handleLogout,
  showWelcomeHighlight
}: UserMenuProps) => (
  <StyledMenu
    id={id}
    anchorEl={anchorEl}
    open={userMenuOpen}
    onClose={handleUserMenuClose}
    className='header__top-menu'
  >
    {showWelcomeHighlight && (
      <CustomMenuItem
        onClick={handleUserMenuClose}
        component={Link}
        href={`${PAGE_PATHS.successPage}`}
        classes={{
          root: classes.root
        }}
        sx={{
          background: showWelcomeHighlight
            ? '#fff'
            : (theme) => theme.palette.primary.main
        }}
      >
        Welcome to TUD+
      </CustomMenuItem>
    )}
    <CustomMenuItem
      onClick={handleUserMenuClose}
      component={Link}
      href={`${USER_ACCOUNT_PATHS.account}/${USER_ACCOUNT_PATHS.manageAccount}`}
      classes={{
        root: classes.root
      }}
    >
      Profile
    </CustomMenuItem>
    <CustomMenuItem
      onClick={handleUserMenuClose}
      component={Link}
      href={`${USER_ACCOUNT_PATHS.account}/${USER_ACCOUNT_PATHS.emailPreferences}`}
      classes={{
        root: classes.root
      }}
    >
      Email Preferences
    </CustomMenuItem>
    <CustomMenuItem
      onClick={handleUserMenuClose}
      component={Link}
      href={`${USER_ACCOUNT_PATHS.account}/${USER_ACCOUNT_PATHS.subscription}`}
      classes={{
        root: classes.root
      }}
    >
      Membership
    </CustomMenuItem>
    <CustomMenuItem
      onClick={handleUserMenuClose}
      component={Link}
      href={`${USER_ACCOUNT_PATHS.account}/${USER_ACCOUNT_PATHS.linkedAccounts}`}
      classes={{
        root: classes.root
      }}
    >
      Account Security
    </CustomMenuItem>

    {/* <CustomMenuItem
      onClick={handleUserMenuClose}
      component={Link}
      href={`${USER_ACCOUNT_PATHS.account}/${USER_ACCOUNT_PATHS.watchlist}`}
      classes={{
        root: classes.root
      }}>
      Watchlist
    </CustomMenuItem>
    <CustomMenuItem
      onClick={handleUserMenuClose}
      component={Link}
      href={`${USER_ACCOUNT_PATHS.account}/${USER_ACCOUNT_PATHS.upcomingEvents}`}
      classes={{
        root: classes.root
      }}>
      Upcoming Events
    </CustomMenuItem>
    <CustomMenuItem
      onClick={handleUserMenuClose}
      component={Link}
      href={`${USER_ACCOUNT_PATHS.account}/${USER_ACCOUNT_PATHS.corporateAccount}`}
      classes={{
        root: classes.root
      }}>
      Corporate Account
    </CustomMenuItem> */}
    <CustomMenuItem
      onClick={handleUserMenuClose}
      component={Link}
      href={`${LINKS.contactSupport}`}
      classes={{
        root: classes.root
      }}
    >
      Contact Support
    </CustomMenuItem>
    {/* {showProfessionalLinks && (
      <Divider />)}
    {showProfessionalLinks && <CustomMenuItem
      onClick={handleUserMenuClose}
      component={Link}
      href={PAGE_PATHS.professionalMembersPages.upcomingWebinars}
      style={{ color: '#fbb040' }}
      classes={{
        root: classes.root
      }}>
      Upcoming Webinars
    </CustomMenuItem>
    }
    {showProfessionalLinks &&
      <CustomMenuItem
        onClick={handleUserMenuClose}
        component={Link}
        href={PAGE_PATHS.professionalMembersPages.tudPlusMembershipOnDemand}
        style={{ color: '#fbb040' }}
        classes={{
          root: classes.root
        }}>
        On Demand Webinars
      </CustomMenuItem>
    } */}
    <Divider />
    <CustomMenuItem
      onClick={() => {
        handleUserMenuClose();
        handleLogout();
      }}
      component='a'
      classes={{
        root: classes.root
      }}
    >
      <Logout style={{ fill: '#FBB040' }} />
      <span className='header__top-menu__text-spacing'>Sign Out</span>
    </CustomMenuItem>
  </StyledMenu>
);

export default UserMenu;
